import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import { SideBarDeleteActionWithPopup } from '../../../../components/commons/SideBarComponents/DeleteActionWithPopup/sideBarDeleteActionWithPopup';
import {
  StyledContainerItems,
  StyledContainerFooterSideBar,
  StyledTitleSideBar,
  StyledContainerSimpleMethod
} from '../../../../components/commons/SideBarComponents/sideBarComponentsStyles';
import Strings from '../../../../i18n';
import {
  useDeleteEventMutation,
  useGetEvenDetailsMutation
} from '../../../../services/events/eventService';
import { IEvent } from '../../../../types/events/eventsInterface';
import { colors } from '../../../../constants/colors';
import { ContainerButton } from '../addEvent/addEventStyles';
import {
  setEditEvent,
  setIsUpdateEvent
} from '../../../../store/slices/locations/location';

interface IEventDetailsProps {
  event: IEvent;
  selectedEvents: IEvent[];
  setSelectedScenes: (scenes: IEvent[]) => void;
  openSideBar: boolean;
  setOpenSideBar: (openSideBar: boolean) => void;
  reloadTable: () => void;
}
export const EventDetails = ({
  event,
  openSideBar,
  selectedEvents,
  setSelectedScenes,
  setOpenSideBar,
  reloadTable
}: IEventDetailsProps) => {
  const [deleteEv, { isSuccess: isSuccessDelete }] = useDeleteEventMutation();
  const dispatch = useDispatch();

  const [getEvent, { isSuccess: isSuccessDetails, data }] =
    useGetEvenDetailsMutation();
  const deleteEvent = () => {
    deleteEv(event.eventId);
  };
  const { locationId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    getEvent(event.eventId);
  }, []);

  useEffect(() => {
    if (isSuccessDelete) {
      setOpenSideBar(false);
      setSelectedScenes([]);
      toast.success(Strings.events.successDeleteEvent);
      reloadTable();
    }
  }, [isSuccessDelete]);

  useEffect(() => {
    if (isSuccessDetails && data) {
      dispatch(setEditEvent(data));
    }
  }, [isSuccessDetails]);

  const redirectToAddEvent = () => {
    navigate(
      `/locations/${locationId}/applications/schedules/add/${
        data?.eventType || 0
      }`
    );
  };
  return (
    <>
      {event && (
        <>
          <StyledContainerItems>
            <StyledTitleSideBar>{event.name}</StyledTitleSideBar>
            <SideBarDeleteActionWithPopup
              onDelete={() => deleteEvent()}
              titleConfirmation={Strings.events.deleteEventTitle}
              textConfirmation={Strings.common.thisActionIsIrreversible}
              textIcon={Strings.events.deleteEvent}
            />
          </StyledContainerItems>
          <ContainerButton>
            <StyledContainerSimpleMethod
              disabled={!isSuccessDetails}
              type="button"
              onClick={() => {
                dispatch(setIsUpdateEvent(true));
                redirectToAddEvent();
              }}
              style={{ color: colors.black }}
            >
              {Strings.events.editEvent}
            </StyledContainerSimpleMethod>
          </ContainerButton>
          <ContainerButton>
            <StyledContainerSimpleMethod
              disabled={!isSuccessDetails}
              type="button"
              onClick={redirectToAddEvent}
              style={{ color: colors.black }}
            >
              {Strings.events.copyEvent}
            </StyledContainerSimpleMethod>
          </ContainerButton>

          <StyledContainerFooterSideBar>
            <button
              type="button"
              className="btn-cancel"
              onClick={() => {
                setOpenSideBar(false);
                setSelectedScenes([]);
              }}
            >
              {Strings.common.cancel}
            </button>
          </StyledContainerFooterSideBar>
        </>
      )}
      <div />
    </>
  );
};
